import { Box, useTheme } from "@mui/material";
import React from "react";

const Tooltip = ({ element }) => {
  const theme = useTheme();
  if (!element) return null;
  const rect = element.getBoundingClientRect();

  return (
    <Box
      sx={{
        position: "absolute",
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        backgroundColor: theme.palette.whiteblack.contrastText,
        color: theme.palette.whiteblack.main,
        fontSize: "0.85rem",
        padding: "5px",
        borderRadius: "3px",
        zIndex: 1000,
      }}
    >
      {element.innerText}
    </Box>
  );
};

export default Tooltip;
